import React from 'react';
import { FileText, AlertTriangle, MapPin } from 'lucide-react';

const SEITEN = [
  {
    title: 'Unfallgutachten',
    beschreibung: 'Wann ein Gutachten sinnvoll ist und wie der Ablauf aussieht.',
    icon: FileText,
    link: '/unfallgutachten'
  },
  {
    title: 'Nach dem Unfall',
    beschreibung: 'Schritt-für-Schritt-Übersicht für Geschädigte nach einem Verkehrsunfall.',
    icon: AlertTriangle,
    link: '/nach-dem-unfall'
  },
  {
    title: 'Bundesweit',
    beschreibung: 'Wie bundesweite Begutachtungen in der Praxis funktionieren.',
    icon: MapPin,
    link: '/bundesweit'
  }
];

export const BrueckeSeiten = () => {
  return (
    <section className="py-28 lg:py-36 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-6xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-brand-green/8 text-brand-green-dark rounded-full text-sm font-semibold mb-6 border border-brand-green/15">
            Informationen
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6 tracking-tight">
            Mehr Informationen
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {SEITEN.map((seite, index) => {
            const Icon = seite.icon;
            return (
              <a key={index} href={seite.link} className="block">
                <div className="bg-white border border-gray-200 rounded-3xl p-8 h-full hover:border-brand-green/30 hover:shadow-xl transition-all duration-300 text-center group">
                  <div className="w-16 h-16 bg-brand-green/10 rounded-2xl flex items-center justify-center mx-auto mb-6 border border-brand-green/15 group-hover:bg-brand-green/15 transition-all">
                    <Icon className="w-8 h-8 text-brand-green" />
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3 tracking-tight group-hover:text-brand-green transition-colors">{seite.title}</h3>
                  <p className="text-gray-600 leading-relaxed text-[15px]">{seite.beschreibung}</p>
                </div>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
};